(ns minorodata.pipeline-dag.timing
  "Per-phase timings for building the dependency graph (fetch, prune, parse, elk-input,
   elk, flatten), recorded via User Timing and announced as `dag:phase` events.")

(def ^:private prefix "dag/")

(def event-name
  "Window event fired as a phase starts (`ms` nil) and ends."
  "dag:phase")

(defn- emit! [phase ms]
  (try
    (js/window.dispatchEvent
     (js/CustomEvent. event-name
                      #js {:detail #js {:phase (name phase) :ms ms}}))
    (catch :default _ nil)))

(defn start!
  "Opens `phase` and announces it; never throws."
  [phase]
  (try (js/performance.mark (str prefix (name phase) ":start"))
       (catch :default _ nil))
  (emit! phase nil))

(defn end!
  "Closes `phase` and announces its duration."
  [phase]
  (try
    (let [n  (str prefix (name phase))
          _  (js/performance.mark (str n ":end"))
          m  (js/performance.measure n (str n ":start") (str n ":end"))
          ms (js/Math.round (or (some-> m .-duration)
                                (some-> (js/performance.getEntriesByName n) last .-duration)
                                0))]
      ;; cleared once read, so relayouts on a long-lived page don't pile up entries
      (js/performance.clearMarks (str n ":start"))
      (js/performance.clearMarks (str n ":end"))
      (js/performance.clearMeasures n)
      (emit! phase ms))
    (catch :default _ nil)))

(defn timed
  "Runs thunk `f` inside `phase`, returning its value."
  [phase f]
  (start! phase)
  (try (f) (finally (end! phase))))

(defn- log-phases!
  "Logs each finished phase to the console; returns the listener."
  []
  (let [f (fn [^js e]
            (let [d (.-detail e)]
              (js/console.debug (str "%c" prefix (.-phase d))
                                "color:#888" (str (.-ms d) "ms"))))]
    (js/window.addEventListener event-name f)
    f))

#_{:clj-kondo/ignore [:unused-private-var]}
(defonce ^:private dev-logging
  ;; dev builds only — goog.DEBUG is false under :advanced
  (when (and ^boolean goog.DEBUG (fn? (.-addEventListener js/window)))
    (log-phases!)))
